import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';

import { fetchFollowers } from 'mewe/fetchers/fetch-pages';
import { ds } from 'mewe/stores/ds';

export default Route.extend({
  theme: Theme.PAGE,

  beforeModel: function () {
    fetchFollowers(this.modelFor('app.publicid').page.id, { 'with-admins': true });
  },

  model() {
    return {
      page: this.modelFor('app.publicid').page,
      followers: ds.followers.for(this.modelFor('app.publicid').page.id),
    };
  },
});
